import { useMemo } from 'react';
import { useServicesChartsDataContext } from './useServicesChartsDataContext';

const useServicesPerUnitPerYearChart = () => {
    const { chartData } = useServicesChartsDataContext();

    const series = useMemo(
        () =>
            chartData.rankingByUnit.map((item) => {
                return Number(item.services);
            }),
        [chartData.rankingByUnit]
    );

    return {
        series,
        subtitles: chartData?.rankingByUnit.map(
            (item) => item.no_razao_social ?? ''
        )
    };
};

export default useServicesPerUnitPerYearChart;
